
import Toast from 'vux/src/components/toast/index.vue'

export default {
components: {
Toast
},
props: {
singleContent: {
default: "",
type: String
},
judgeChooseItem: {
default: function() {
return [];
},
type: Array
},
judge_fav: {
default: false,
type: Boolean
},
judgeStatus: {
default: false,
type: Boolean
},
select_id: {
default: "0"
},
pageKind: {
default: "",
type: String
},
dataIndex: {
default: 1,
type: Number
}
},
data() {
return {
newList: null,
subjectIndex: 0,
itemList: [],
showSubmit: true,
showFav: false,
select_target: "",
right_id: 0,
right_target: "",
judgeItem: "",
tabKind: "judge",
key: "",
courseId: 0
};
},
watch: {
judgeChooseItem: {
handler(newVal, oldVal) {
this.itemList = JSON.parse(JSON.stringify(this.judgeChooseItem));
this.itemList.forEach(item => {
if (item.id == this.select_id) {
this.$set(item, "showChoose", true);
}
});
},
immediate: true
},
judge_fav: {
handler() {
this.showFav = this.judge_fav;
},
immediate: true
},










judgeStatus: {
handler(newVal, oldVal) {
if (newVal) {
this.showSubmit = false;
} else {
this.showSubmit = true;
}
},
immediate: true
}
},
created() {
this.keys = this.$route.query.keys;
this.courseId = this.$route.query.courseId;
},
methods: {
goNext() {
this.subjectIndex += 1;
this.$emit("goNext", this.subjectIndex);
},
goBack() {
this.$emit("goBack");
},
judgeSubmit() {
let j = this.itemList.find(item=>{
return item.showChoose == true
})
this.$emit("judgeSubmit", j.target, this.itemList);
},
chooseItem(val) {
if (this.pageKind === "exam") {
this.itemList.forEach(item => {
this.$set(item, "showChoose", false);
delete item.showChoose;
});
this.$set(val, "showChoose", true);
this.judgeItem = val.target;
this.$emit(
"chooseItem",
this.tabKind,
val.id,
this.judgeItem,
this.itemList
);
return;
}

if (!this.showSubmit) return;
if (val.showChoose) {
return;
}

this.itemList.forEach(item => {
this.$set(item, "showChoose", false);
delete item.showChoose;
});
this.$set(val, "showChoose", true);
this.judgeItem = val.target;
this.$emit(
"chooseItem",
this.tabKind,
val.id,
this.judgeItem,
this.itemList
);
},
collect() {
this.$emit("collect");

},
unCollect() {
this.$emit("unCollect");

},
deleteItem() {
this.$emit("deleteItem");
}
}
};



// WEBPACK FOOTER //
// ./src/components/exam/judgeSubject.vue